/**
 * Cloudflare Turnstile on the booking page's forms (submit, call-back,
 * "find my record"). The site key comes from the API at runtime on the
 * public site (`site.turnstile`, from `VELORA_TURNSTILE_SITE_KEY`), never
 * from the build. Without one nothing renders and the API skips the check;
 * the persistent rate limits apply either way (docs/security/turnstile.md).
 */
import type { TurnstileAction, TurnstilePublic } from '@velora/contracts/turnstile';
import { Turnstile, type TurnstileHandle } from '@velora/ui';
import { forwardRef } from 'react';

export type { TurnstileHandle };

/** True when the API will refuse this request without a token. */
export function botTokenMissing(bot: TurnstilePublic | undefined, token: string | null): boolean {
  return bot?.mode === 'enforce' && Boolean(bot.siteKey) && !token;
}

export const BOT_WAIT_MESSAGE = 'Please complete the check below first.';

export const BotCheck = forwardRef<
  TurnstileHandle,
  {
    bot: TurnstilePublic | undefined;
    action: TurnstileAction;
    onToken: (token: string | null) => void;
  }
>(function BotCheck({ bot, action, onToken }, ref) {
  return (
    <Turnstile
      ref={ref}
      siteKey={bot?.siteKey ?? null}
      action={action}
      onToken={onToken}
      className="bw-turnstile"
    />
  );
});
